var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { RequestError } from '../../utils/RequestError';
var BaseService = /** @class */ (function () {
    function BaseService(path, baseUrl) {
        if (baseUrl === void 0) { baseUrl = ""; }
        this.baseUrl = baseUrl;
        this.path = path;
    }
    Object.defineProperty(BaseService.prototype, "Url", {
        get: function () {
            return [this.baseUrl, this.path].filter(function (a) { return a; }).join('/');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseService.prototype, "Authorization", {
        get: function () {
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    BaseService.prototype.fetch = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedOptions, response, contentLength, error, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mergedOptions = __assign(__assign({}, options), { headers: __assign(__assign({ Accept: 'application/json', 'Content-Type': (options === null || options === void 0 ? void 0 : options.body) instanceof FormData ? 'multipart/form-data' : 'application/json' }, (this.Authorization ? { Authorization: this.Authorization } : {})), options === null || options === void 0 ? void 0 : options.headers) });
                        return [4 /*yield*/, fetch(url, mergedOptions)];
                    case 1:
                        response = _c.sent();
                        if (!!response.ok) return [3 /*break*/, 5];
                        contentLength = Number(response.headers.get('Content-Length'));
                        error = void 0;
                        if (!(!isNaN(contentLength) && contentLength > 0)) return [3 /*break*/, 3];
                        _a = RequestError.bind;
                        _b = [void 0, response, mergedOptions];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        error = new (_a.apply(RequestError, _b.concat([_c.sent()])))();
                        return [3 /*break*/, 4];
                    case 3:
                        error = new RequestError(response, mergedOptions);
                        _c.label = 4;
                    case 4: throw error;
                    case 5:
                        if (!response.headers.get('Content-Type')) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, response.json()];
                    case 6: return [2 /*return*/, (_c.sent())];
                }
            });
        });
    };
    BaseService.prototype.parseBody = function (body) {
        if (body instanceof FormData) {
            return {
                body: body,
                headers: { 'Content-Type': 'multipart/form-data' },
            };
        }
        if (body instanceof URLSearchParams) {
            return {
                body: body.toString(),
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            };
        }
        return { body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } };
    };
    BaseService.prototype.get = function (path, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("".concat(this.Url, "/").concat(path), __assign(__assign({}, options), { method: 'GET' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BaseService.prototype.post = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, parsedBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.parseBody(body), headers = _a.headers, parsedBody = _a.body;
                        return [4 /*yield*/, this.fetch("".concat(this.Url, "/").concat(path), __assign(__assign({}, options), { method: 'POST', body: parsedBody, headers: __assign(__assign({}, headers), options === null || options === void 0 ? void 0 : options.headers) }))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    BaseService.prototype.put = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, parsedBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.parseBody(body), headers = _a.headers, parsedBody = _a.body;
                        return [4 /*yield*/, this.fetch("".concat(this.Url, "/").concat(path), __assign(__assign({}, options), { method: 'PUT', body: parsedBody, headers: __assign(__assign({}, headers), options === null || options === void 0 ? void 0 : options.headers) }))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    BaseService.prototype.delete = function (path, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("".concat(this.Url, "/").concat(path), __assign(__assign({}, options), { method: 'DELETE' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BaseService;
}());
export { BaseService };
